var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseActionTimeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_12131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_873_12131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27201 12.0024C10.0348 12.0024 12.2745 9.76274 12.2745 6.99995C12.2745 4.23716 10.0348 1.99747 7.27201 1.99747C4.50921 1.99747 2.26953 4.23715 2.26953 6.99994C2.26953 9.76273 4.50922 12.0024 7.27201 12.0024Z",
    stroke: "#3A3A3A",
    strokeWidth: 1.00049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27148 3.99847L7.27148 6.99996L9.27247 8.00045",
    stroke: "#3A3A3A",
    strokeWidth: 1.00049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_12131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15.2727,
    fill: "white",
    transform: "translate(15.2725) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_873_12131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0059,
    height: 12.0059,
    fill: "white",
    transform: "translate(1.26904 0.99704)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseActionTimeIc);
export default __webpack_public_path__ + "static/media/course_action_time_ic.889334a45573c28b87f7bc78532dd646.svg";
export { ForwardRef as ReactComponent };